{
  "title": "Transiente & Mieter-Flugzeuge – {{fboName}}",
  "search": {
    "placeholder": "Suche Kennz., Eigentümer, Modell"
  },
  "filters": {
    "showTenants": {
      "label": "Mandanten anzeigen",
      "all": "Alle Mandanten anzeigen",
      "unassigned": "Nicht zugewiesen",
      "assignedTo": "Zugewiesen an {{locationName}}"
    },
    "currentLocation": {
      "label": "Akt. Standort"
    }
  },
  "columns": {
    "tailNumber": "Kennz.",
    "ownerManager": "Inhaber/Manager",
    "model": "Modell",
    "currentLocation": "Aktueller Standort",
    "assignedLocation": "Zugew. Standort",
    "type": "Typ",
    "lastHangared": "Zuletzt im Hangar",
    "note": "Info"
  },
  "actions": {
    "edit": "Bearb."
  },
  "deleteConfirmation": {
    "title": "Möchtest du {{identifier}} wirklich löschen?",
    "message": "Dieses Flugzeug wird dauerhaft gelöscht.",
    "confirm": "Ja"
  },
  "locationText": {
    "notHangared": "Nicht im Hangar"
  }
}
